import consts from "./consts.js";

/**
 * 获取用户信息缓存
 * 从 localStorage 中读取 KEY_INFO 对应的数据并解析为对象
 * @returns {Object|null} 用户信息对象，失败或不存在时返回 null
 */
export function getUserInfo() {
  try {
    const raw = localStorage.getItem(consts.KEY_INFO);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    console.error("getUserInfo 解析失败:", e);
    return null;
  }
}

/**
 * 获取 Token 缓存
 * @returns {string|null}
 */
export function getToken() {
  return localStorage.getItem(consts.KEY_TOKEN);
}

/**
 * 通用获取缓存方法
 * @param {string} key consts 中定义的键名
 * @returns {Object|string|null}
 */
export function getCache(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return raw;
    }
  } catch (e) {
    return null;
  }
}

/**
 * 更新用户信息缓存的指定字段
 * @param {Object} fields 要更新的字段对象
 */
export function updateUserInfo(fields) {
  try {
    const raw = localStorage.getItem(consts.KEY_INFO);
    let info = {};
    if (raw) {
      info = JSON.parse(raw);
    }
    const merged = deepMerge(info, fields);
    localStorage.setItem(consts.KEY_INFO, JSON.stringify(merged));
    return merged;
  } catch (e) {
    console.error("updateUserInfo 更新失败:", e);
    return null;
  }
}

/**
 * 通用更新缓存方法
 * @param {string} key consts 中定义的键名
 * @param {Object} fields 要更新的字段
 */
export function updateCache(key, fields) {
  try {
    const raw = localStorage.getItem(key);
    let data = {};
    if (raw) {
      try {
        data = JSON.parse(raw);
      } catch {
        data = {};
      }
    }
    const merged = deepMerge(data, fields);
    localStorage.setItem(key, JSON.stringify(merged));
    return merged;
  } catch (e) {
    return null;
  }
}

/**
 * 深合并工具函数
 */
function deepMerge(target, source) {
  const result = { ...target };
  for (const key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (
        typeof source[key] === "object" &&
        source[key] !== null &&
        !Array.isArray(source[key]) &&
        typeof result[key] === "object" &&
        result[key] !== null &&
        !Array.isArray(result[key])
      ) {
        result[key] = deepMerge(result[key], source[key]);
      } else {
        result[key] = source[key];
      }
    }
  }
  return result;
}
